import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { OrdersState, RootState } from '../types';

const namespaced: boolean = true;

export const state: OrdersState = {
	orders: [],
	currentOrders: [],
	selectedOrder: {} as Order,
	orderDetails: {
		type: '',
		tableArea: '',
		tableLocation: '',
		tableNum: '',
		takeoutType: '',
		checkNum: ''
	},
	// item selected from the menu
	selectedItem: null,
	// section slug for the selected item
	selectedSectionSlug: '',
	// item to be added to the order
	orderItem: null,
	editingItem: false,
	modifyingOrder: false,
	isQuoting: false,
	orderValidationErrors: {},
	repeatOrderNotices: null,
	orderItemPrice: 0,
	cart: {
		items: [],
		cartIndex: 0
	},
	items: [],
	checkout: {
		pickup: null,
		delivery: {
			type: '',
			address: ''
		},
		contact: {
			full_name: '',
			email: '',
			phone_number: ''
		},
		cateringEvent: null,
		quoteInfo: null,
		loyaltyProgram: null,
		memberInfo: null,
		questions: null,
		invoice: false,
		costCenter: '',
		purchaseOrder: '',
		autoAccept: false
	},
	membershipLookup: null,
	costs: {
		subtotal: 0,
		subtotalDiscounted: 0,
		taxBrackets: {},
		taxes: 0,
		tip: {
			percentageValue: 0,
			amount: 0,
			type: 'dollar'
		},
		serviceCharge: {
			percentageValue: 0,
			amount: 0,
			type: 'dollar',
			label: '',
			feeModified: false
		},
		deliveryCharge: {
			percentageValue: 0,
			amount: 0,
			type: 'dollar',
			feeModified: false
		},
		voucher: {
			code: '',
			balance: 0,
			amount: 0
		},
		discount: {
			percentageValue: 0,
			amount: 0,
			type: 'percentage',
			code: ''
		},
		// not used, but needed for cost calculation to work
		subsidyDiscount: {
			type: '',
			chosenAmountToBePaid: undefined,
			code: undefined,
			amount: 0,
			baseSubsidizedAmount: 0
		},
		memberDiscount: {
			preTax: false,
			amount: 0
		},
		total: 0,
		totalWithTip: 0
	},
	queue: {} as QueueInfo,
	chosenCreditCard: null,
	activeModificationRequest: null,
	itemSort: null,
	itemDiets: []
};

export const Orders: Module<OrdersState, RootState> = {
	namespaced,
	state,
	mutations,
	getters,
	actions
};

export default Orders;